import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { ArrowRightIcon, CalendarIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function BlogSection() {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section className="py-20 lg:py-28 bg-navy-50/50" id="blog" data-id="element-69">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" ref={ref} data-id="element-70">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5
      }} className="flex flex-col sm:flex-row sm:items-end sm:justify-between mb-14" data-id="element-71">
          <div data-id="element-72">
            <span className="text-sm font-semibold text-primary-600 tracking-wide uppercase" data-id="element-73">
              Блог
            </span>
            <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold text-navy-900 tracking-tight" data-id="element-74">
              Статті та кейси
            </h2>
          </div>
          <Link to="/blog" className="mt-4 sm:mt-0 inline-flex items-center gap-1 text-primary-600 font-semibold hover:text-primary-700 transition-colors" data-id="element-75">
            Усі статті
            <ArrowRightIcon className="w-4 h-4" data-id="element-76" />
          </Link>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-77">
          {/* Article 1 */}
          <motion.article initial={{
          opacity: 0,
          y: 24
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="group bg-white rounded-2xl border border-navy-100 overflow-hidden hover:shadow-lg transition-shadow cursor-pointer" data-id="element-78">
            <div className="aspect-[16/10] bg-gradient-to-br from-primary-100 to-cyan-100 flex items-center justify-center overflow-hidden" data-id="element-79">
              <div className="w-20 h-20 rounded-2xl bg-primary-500/20 flex items-center justify-center" data-id="element-80">
                <span className="text-3xl" data-id="element-81">📊</span>
              </div>
            </div>
            <div className="p-6" data-id="element-82">
              <div className="flex items-center gap-2 text-sm text-navy-400 mb-3" data-id="element-83">
                <CalendarIcon className="w-4 h-4" data-id="element-84" />
                <span data-id="element-85">15 лютого 2026</span>
                <span className="px-2 py-0.5 bg-primary-50 text-primary-600 rounded-md text-xs font-medium" data-id="element-86">
                  Кейс
                </span>
              </div>
              <h3 className="text-lg font-bold text-navy-900 group-hover:text-primary-600 transition-colors" data-id="element-87">
                Як ми зібрали IT‑відділ із 15 людей за 6 тижнів
              </h3>
              <p className="mt-2 text-sm text-navy-500 leading-relaxed" data-id="element-88">
                Розповідаємо про стратегію масового найму для швидкозростаючого
                фінтех‑стартапу та результати через півроку.
              </p>
            </div>
          </motion.article>

          {/* Article 2 */}
          <motion.article initial={{
          opacity: 0,
          y: 24
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="group bg-white rounded-2xl border border-navy-100 overflow-hidden hover:shadow-lg transition-shadow cursor-pointer" data-id="element-89">
            <div className="aspect-[16/10] bg-gradient-to-br from-amber-100 to-orange-100 flex items-center justify-center overflow-hidden" data-id="element-90">
              <div className="w-20 h-20 rounded-2xl bg-amber-500/20 flex items-center justify-center" data-id="element-91">
                <span className="text-3xl" data-id="element-92">💡</span>
              </div>
            </div>
            <div className="p-6" data-id="element-93">
              <div className="flex items-center gap-2 text-sm text-navy-400 mb-3" data-id="element-94">
                <CalendarIcon className="w-4 h-4" data-id="element-95" />
                <span data-id="element-96">8 лютого 2026</span>
                <span className="px-2 py-0.5 bg-amber-50 text-amber-600 rounded-md text-xs font-medium" data-id="element-97">
                  Стаття
                </span>
              </div>
              <h3 className="text-lg font-bold text-navy-900 group-hover:text-primary-600 transition-colors" data-id="element-98">
                5 помилок при наймі топ‑менеджерів та як їх уникнути
              </h3>
              <p className="mt-2 text-sm text-navy-500 leading-relaxed" data-id="element-99">
                Розбираємо типові помилки компаній при пошуку C‑level керівників
                та ділимося перевіреними підходами.
              </p>
            </div>
          </motion.article>

          {/* Article 3 */}
          <motion.article initial={{
          opacity: 0,
          y: 24
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="group bg-white rounded-2xl border border-navy-100 overflow-hidden hover:shadow-lg transition-shadow cursor-pointer" data-id="element-100">
            <div className="aspect-[16/10] bg-gradient-to-br from-emerald-100 to-teal-100 flex items-center justify-center overflow-hidden" data-id="element-101">
              <div className="w-20 h-20 rounded-2xl bg-emerald-500/20 flex items-center justify-center" data-id="element-102">
                <span className="text-3xl" data-id="element-103">🌍</span>
              </div>
            </div>
            <div className="p-6" data-id="element-104">
              <div className="flex items-center gap-2 text-sm text-navy-400 mb-3" data-id="element-105">
                <CalendarIcon className="w-4 h-4" data-id="element-106" />
                <span data-id="element-107">1 лютого 2026</span>
                <span className="px-2 py-0.5 bg-emerald-50 text-emerald-600 rounded-md text-xs font-medium" data-id="element-108">
                  Огляд
                </span>
              </div>
              <h3 className="text-lg font-bold text-navy-900 group-hover:text-primary-600 transition-colors" data-id="element-109">
                Ринок праці 2026: тренди та прогнози для роботодавців
              </h3>
              <p className="mt-2 text-sm text-navy-500 leading-relaxed" data-id="element-110">
                Аналізуємо ключові тенденції ринку праці та даємо рекомендації
                щодо стратегії найму на найближчий рік.
              </p>
            </div>
          </motion.article>
        </div>
      </div>
    </section>;
}